import type { ApiDelivery } from '@/features/kitchen/api/getTodayDispatch'
import type { ShipmentRecord } from '@/features/kitchen/storage/dispatchStorage'

export type ApiShipment = ShipmentRecord & {
  deliveryId: string
}

export function mapDeliveriesFromApi(deliveries: ApiDelivery[]): ApiShipment[] {
  return deliveries.map((d) => ({
    deliveryId: d.id,
    id: d.code || d.id,
    storeName: d.store_name,
    delmanName: d.delman_name,
    status: d.status,
    updatedAt: d.updated_at,
    lines: (d.lines ?? []).map((line) => ({
      id: line.id,
      productName: line.product_name,
      productionDate: line.production_date,
      qty: line.qty,
    })),
  }))
}

export function buildDispatchSummaryFromShipments(
  shipments: Pick<ShipmentRecord, 'status' | 'storeName'>[],
) {
  const pending = shipments.filter((s) => s.status === 'draft' || s.status === 'prepared')
  const inTransit = shipments.filter((s) => s.status === 'in_transit')
  const prepared = shipments.filter((s) => s.status === 'prepared')

  return {
    pendingCount: pending.length,
    preparedCount: prepared.length,
    inTransitCount: inTransit.length,
    pendingStores: pending.map((s) => s.storeName),
  }
}
